import { VariantColor } from '@repo/toolkit/colors'

export enum CenterOlPaymentTypeEnum {
  ADVANCE = 'ADVANCE',
  COST = 'COST',
  FINAL = 'FINAL'
}

export const centerOlPaymentTypeMapping: Record<
  CenterOlPaymentTypeEnum,
  {
    label: string
    variant: VariantColor
  }
> = {
  [CenterOlPaymentTypeEnum.ADVANCE]: { label: 'Advance', variant: 'orange' },
  [CenterOlPaymentTypeEnum.COST]: { label: 'Before stay payment', variant: 'blue' },
  [CenterOlPaymentTypeEnum.FINAL]: { label: 'Final balance', variant: 'success' }
}
